import type { EditorPluginAIPromptResponseMarkdown } from '../../types';

export async function* elevateFreeGenerateDisabled(): AsyncGenerator<EditorPluginAIPromptResponseMarkdown> {
	return yield {
		state: 'failed',
		reason: 'free-generate-disabled',
		statusCode: 9001,
	};
}
